// Fetch Request
import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster'
import { setSiteSettings } from '../../../actions/siteSettings';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  if (!values?.ogImage) {
    return showToaster({ messageId: 'ogImageError', toasterType: 'error' })
  }

  let variables = {
    ...values,
    homePageType: Number(values?.homePageType),
    phoneNumberStatus: Number(values?.phoneNumberStatus),
    appAvailableStatus: values?.appAvailableStatus == 1 ? true : false,
    securityDepositPreference: Number(values?.securityDepositPreference),
    isPromoCodeEnabled: String(values?.isPromoCodeEnabled)
  };


  const query = `
  query (
    $siteName: String,
    $siteTitle: String,
    $metaDescription: String,
    $metaKeyword: String,
    $logo: String,
    $facebookLink: String,
    $twitterLink: String,
    $instagramLink: String
    $homePageType: Int,
    $phoneNumberStatus: Int,
    $appAvailableStatus: Boolean,
    $playStoreUrl: String,
    $appStoreUrl: String,
    $email: String,
    $phoneNumber: String,
    $address: String,
    $appForceUpdate: String,
    $androidVersion: String,
    $iosVersion: String,
    $ogImage: String,
    $securityDepositPreference: Int
  ) {
    updateSiteSettings (
      siteName: $siteName,
      siteTitle: $siteTitle,
      metaDescription: $metaDescription,
      metaKeyword: $metaKeyword,
      logo: $logo,
      facebookLink: $facebookLink,
      twitterLink: $twitterLink,
      instagramLink: $instagramLink,
      homePageType: $homePageType,
      phoneNumberStatus: $phoneNumberStatus,
      appAvailableStatus: $appAvailableStatus,
      playStoreUrl: $playStoreUrl,
      appStoreUrl: $appStoreUrl,
      email: $email,
      phoneNumber: $phoneNumber,
      address: $address,
      appForceUpdate: $appForceUpdate,
      androidVersion: $androidVersion,
      iosVersion: $iosVersion,
      ogImage: $ogImage,
      securityDepositPreference: $securityDepositPreference
    ) {
        status
    }
  }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();
  if (data?.updateSiteSettings?.status === "success") {
    showToaster({ messageId: 'settingsUpdate', toasterType: 'success' })
    dispatch(setSiteSettings());

  } else {
    showToaster({ messageId: 'settingsUpdateFailed', toasterType: 'error' })
  }

}

export default submit;
